"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSpacings = {
    margin: {
        spacing4xs: '0.25rem',
        spacing3xs: '0.5rem',
        spacing2xs: '0.75rem',
        spacingXs: '1rem',
        spacingSm: '1.25rem',
        spacingMd: '1.5rem',
        spacingLg: '2rem',
        spacingXl: '2.5rem',
        spacing2xl: '3rem',
        spacing3xl: '3.5rem',
        spacing4xl: '4rem',
    },
    padding: {
        spacing4xs: '0.25rem',
        spacing3xs: '0.5rem',
        spacing2xs: '0.75rem',
        spacingXs: '1rem',
        spacingSm: '1.25rem',
        spacingMd: '1.5rem',
        spacingLg: '2rem',
        spacingXl: '2.5rem',
        spacing2xl: '3rem',
        spacing3xl: '3.5rem',
        spacing4xl: '4rem',
    },
    layout: {
        spacing3xs: '0.5rem',
        spacing2xs: '1rem',
        spacingXs: '1.5rem',
        spacingSm: '2rem',
        spacingMd: '2.5rem',
        spacingLg: '3rem',
        spacingXl: '3.5rem',
        spacing2xl: '4rem',
        spacing3xl: '5rem',
        spacing4xl: '8rem',
        spacing5xl: '12rem',
    },
    lineHeight: {
        lineXs: 1,
        lineSm: 1.2,
        lineMd: 1.5,
        lineLg: 2,
    },
    gutter: {
        spacingGutter: '1rem',
    },
};
exports.default = baseSpacings;
//# sourceMappingURL=baseSpacings.js.map